import React from 'react'
import PurchaseSummary from './PurchaseSummary'

export default function CompletedFishPurSummary() {
    return (
        <PurchaseSummary xState={'CONFIRM'} />
    )
}
